export default __webpack_public_path__ + "static/media/slide_nosotros_mobile.6c6e71e5.png";